import React, { useMemo } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  keyframes,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import starIcon from "../../assets/icons/star-icon.svg";
import cardUpperLine from "../../assets/icons/card-upper-line.svg";
import cardSideLine from "../../assets/icons/card-side-line.svg";
interface Props {
  cardDifficulty: Difficulty;
  cardImg: string;
  hiddenImg: string;
}

const sxStyles = {
  mainContainer: {
    display: "flex",
    height: "500px",
    width: "325px",
  },
  cardDifficultyText: {
    color: "white",
    fontFamily: "p22-arts-and-crafts",
    fontSize: "32px",
    fontWeight: "700",
    lineHeight: "40px",
    marginRight: "45px",
  },
  difficultyContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "25px",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    padding: "0px",
    overflow: "hidden",
    position: "relative",
  },
  imgContainer: {
    height: "415px",
    width: "295px",
    marginRight: "5px",
  },
};

export enum Difficulty {
  FÁCIL = "FACIL",
  MEDIANAS = "MEDIANAS",
  DIFÍCILES = "DIFICILES",
}

const hide = keyframes`
  0% {
    transform: translateX(0);
  }
 10% {
    transform: translateX(0);
  }
  30% {
    transform: translateX(100px);
  }
  80% {
    transform: translateX(100px);
  }
  90% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(0px);
  }
`;
const display = keyframes`
  0% {
    transform: translateX(-295px);
  }
  100% {
    transform: translateX(295px);
  }
`;
type HiddenImgProps = {
  isSelected: boolean;
};
const HiddenCardBounce = styled("img")<HiddenImgProps>(({ isSelected }) => ({
  animation: isSelected
    ? `${display} 1s ease-in-out forwards`
    : `${hide} 3s ease-in-out infinite`,
  transition: "transform 1s ease-in-out",
  left: "-295px",
  position: "absolute",
  zIndex: 1,
  width: "295px",
  objectFit: "contain",
}));

const starsPerDifficulty = {
  [Difficulty.FÁCIL]: 1,
  [Difficulty.MEDIANAS]: 2,
  [Difficulty.DIFÍCILES]: 3,
};
const CollectibleCard = (props: Props) => {
  const { cardDifficulty, cardImg } = props;
  const [isSelected, setIsSelected] = React.useState(false);

  const hiddenCardComputedStyles = useMemo(() => {
    if (isSelected) {
      return {
        transform: "translateX(295px)",
        animation: "none",
        transition: "transform 1s ease-in-out",
      };
    }
    return undefined;
  }, [isSelected]);
  return (
    <Stack sx={sxStyles.mainContainer}>
      <Grid sx={sxStyles.difficultyContainer}>
        <Typography sx={sxStyles.cardDifficultyText}>
          {cardDifficulty}
        </Typography>
        {[...Array(starsPerDifficulty[cardDifficulty])].map((_, index) => (
          <img key={index} src={starIcon} />
        ))}
      </Grid>
      <img src={cardUpperLine} style={{ width: "305px" }} />
      <CardContent sx={sxStyles.cardContainer}>
        <HiddenCardBounce src={props.hiddenImg} isSelected={isSelected} />
        <CardActionArea
          sx={sxStyles.imgContainer}
          onClick={() => {
            setIsSelected(true);
          }}
        >
          <img src={cardImg} />
        </CardActionArea>
        <img src={cardSideLine} />
      </CardContent>
    </Stack>
  );
};

export default CollectibleCard;
